import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, ValidationErrors, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { Subscription } from 'rxjs';

import { BackLinkInterface } from '~/checkout/interfaces/back-link.interface';
import { CtaButtonTypeEnum } from '~/component/call-to-action/enums/button-type.enum';
import { Type } from '~/component/form/input/enums/type.enum';
import { Activity } from '~/core/model/activity.model';
import { MatchMediaService } from '~/core/services/match-media/match-media.service';
import { RedirectionService } from '~/core/services/redirection/redirection.service';
import { ActivitySelectionService } from '~/organizer/activity-planning/services/activity-selection.service';

@Component({
  selector: 'app-organizer-timeslot-pre-schedule-group-size',
  templateUrl: './group-size.component.html',
})
export class OrganizerTimeslotPagePreScheduleGroupSizeComponent
  implements OnInit, OnDestroy
{
  private readonly subscriptions = new Subscription();

  private activity: Activity;

  public readonly ctaButtonType = CtaButtonTypeEnum;

  public groupSize: FormControl;
  public inputType = Type.Number;
  public isTabletDevice: boolean;

  constructor(
    private readonly activitySelectionService: ActivitySelectionService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly redirectionService: RedirectionService,
    private readonly matchMediaService: MatchMediaService,
    private readonly localizeRouterService: LocalizeRouterService
  ) {}

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public ngOnInit(): void {
    this.groupSize = new FormControl(0, [Validators.required]);
    this.subscriptions.add(
      this.activatedRoute.data.subscribe(({ activityData }) => {
        this.activity = activityData.activity;
        this.groupSize.setValue(
          this.activitySelectionService.getOverloads(this.activity.sku)
            .maximumAttendeeCapacity ??
            this.activity.indicativeMaximumAttendeeCapacity
        );
      })
    );

    this.subscriptions.add(
      this.matchMediaService.isTabletDevice().subscribe((isTabletDevice) => {
        this.isTabletDevice = isTabletDevice;
      })
    );
  }

  public get backLink(): BackLinkInterface {
    return {
      path: this.localizeRouterService
        .translateRoute(`/organizer.timeslot.pre-schedule/${this.activity.sku}`)
        .toString(),
    };
  }

  public get errors(): ValidationErrors {
    return this.groupSize.errors;
  }

  public get hasErrors(): boolean {
    return !!this.errors;
  }

  public get hasHeader(): boolean {
    return !this.isTabletDevice;
  }

  public submit(): void {
    this.activitySelectionService.setOverloads(this.activity.sku, {
      maximumAttendeeCapacity: +this.groupSize.value,
    });

    const url = `organizer.timeslot.pre-schedule/${this.activity.sku}`;
    this.redirectionService.redirect(url);
  }
}
